var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8904)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.125,
    r: 5,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 4.88922L3.37915 6.15718L3.37915 3.62126L5.57532 4.88922Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.8764L3.2486 2.125L2 3.3736L3.7514 5.125L2.00001 6.87639L3.24861 8.12499L5 6.3736L6.75139 8.12499L7.99999 6.87639L6.2486 5.125L8 3.3736L6.7514 2.125L5 3.8764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.125,
    r: 5,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 4.88922L3.37915 6.15718L3.37915 3.62126L5.57532 4.88922Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79995 2.88901L7.23595 2.32501L4.99995 4.56101L2.76395 2.32501L2.19995 2.88901L4.43595 5.12501L2.19995 7.36101L2.76395 7.92501L4.99995 5.68901L7.23595 7.92501L7.79995 7.36101L5.56395 5.12501L7.79995 2.88901Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.b57c48efbf6785488926e0eb57f66f27.svg";
export { ForwardRef as ReactComponent };